import { render } from "./WebPage.vue?vue&type=template&id=60884bb7"
import script from "./WebPage.vue?vue&type=script&lang=js"
export * from "./WebPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jjviglio/OpenMCT/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__